module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("赛门铁克杀毒软件—windows客户端")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("请根据具体的操作系统选择相应的软件包，参考 “"), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.kmUrl('https://km.sankuai.com/page/18286732#id-%E7%B3%BB%E7%BB%9F%E7%89%88%E6%9C%AC%E6%9F%A5%E7%9C%8B%E6%96%B9%E6%B3%95')
      }
    }
  }, [_vm._v("系统版本查看方法")]), _vm._v("”")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("一、系统要求")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("该软件目前支持 windows (vista/7/8/10) 32位和64位。")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("系统版本查看方法")]), _c('br'), _c('br'), _vm._v("\n  1.在桌面“计算机”图标上右键，点击“属性”："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic1.png"),
      "width": "230px",
      "height": "230px"
    }
  }), _c('br'), _vm._v("\n  2.如果桌面上没有“计算机”图标，则点击左下角“开始”图标->“计算机”->右键“属性”："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic2.png"),
      "width": "400px",
      "height": "330px"
    }
  }), _c('br'), _vm._v("\n  3.在弹出的窗口中可以看到系统是32位还是64位："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic3.png"),
      "width": "550px",
      "height": "380px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("二、注意事项")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("如果系统安装有第三方安全软件如（包含但不仅限）：360安全卫士、百度杀毒、腾讯管家等，请先卸载")]), _c('br'), _c('br'), _vm._v("\n  如果安装失败或有任何软件问题，请联系6000"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("三、下载地址")]), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("点击SEP图标，根据操作系统类型选择安装包：")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("四、安装步骤 ")]), _c('br'), _c('br'), _vm._v("\n  1.在下载地址 ，根据不同的系统类型下载安装包，双击打开"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic4.png"),
      "width": "550px",
      "height": "380px"
    }
  }), _c('br'), _vm._v("\n  2.选择目标文件夹，点击解压"), _c('br'), _vm._v("\n  3.右键，选择“以管理员身份运行”，运行 MTSymantec-32(64).exe"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic5.png"),
      "width": "110px",
      "height": "110px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic6.png"),
      "width": "400px",
      "height": "300px"
    }
  }), _c('br'), _vm._v("\n  4.双击setup.exe,弹出如下界面，等待一会儿"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic7.png"),
      "width": "550px",
      "height": "300px"
    }
  }), _c('br'), _vm._v("\n  5."), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("安装过程中，程序会自动识别您的mis账号并注册，若无法识别，程序会打开一个浏览器，并打开一个如下的注册页面，需要登陆SSO后方可成功注册，若未登陆SSO，将自动跳转至登陆页面")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic8.png"),
      "width": "550px",
      "height": "300px"
    }
  }), _c('br'), _vm._v("\n  6.若注册成功，页面显示如下："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic9.png"),
      "width": "550px",
      "height": "250px"
    }
  }), _c('br'), _vm._v("\n  7.安装完毕弹出如下界面，点击立即重启"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic10.png"),
      "width": "550px",
      "height": "250px"
    }
  }), _c('br'), _vm._v("\n  8.安装并重启完成，右下角会出现sep的图标："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic11.png"),
      "width": "350px",
      "height": "250px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("五、注册结果查询 ")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(2), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "25px"
    }
  }, [_vm._v("1.注册结果查询")]), _c('br'), _vm._v("\n  请到以下地址查询是否注册成功："), _c('br'), _vm._v("\n  https://reg-sec.meituan.com/api/symantec/status?mis=请输入你的mis账号"), _c('br'), _vm._v("\n  如图："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic12.png"),
      "width": "700px",
      "height": "100px"
    }
  }), _c('br'), _c('br'), _vm._v("\n  如果出现 symantec: installed 字样，代表已经安装并成功注册。"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic13.png"),
      "width": "700px",
      "height": "100px"
    }
  }), _c('br'), _c('br'), _vm._v("\n  如显示symantec:uninstalled，说明未注册成功"), _c('br'), _vm._v("\n  未注册成功解决办法：请参考本wiki内的，未注册成功"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "25px"
    }
  }, [_vm._v("2.Windows未注册成功")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(3), _c('br'), _c('br'), _vm._v("\n    1.请下载windows版的工具：\n  "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.kmUrl('https://share.neixin.cn/link/CK4vW683')
      }
    }
  }, [_vm._v("windows工具下载地址")]), _c('br'), _vm._v("\n    2.下载后，双击运行，若出现如下图的提示，请选择“允许使用此文件”"), _c('br'), _vm._v("\n    "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic14.png"),
      "width": "800px",
      "height": "500px"
    }
  }), _c('br'), _c('br'), _vm._v("\n  3.运行之后，会自动打开浏览器并打开注册页面（如下图），"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("需要登陆SSO后方可成功注册，若未登陆SSO，将自动跳转至登陆页面")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic15.png"),
      "width": "600px",
      "height": "380px"
    }
  }), _c('br'), _c('br'), _vm._v("\n  4.若注册成功，页面显示如下："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic16.png"),
      "width": "600px",
      "height": "300px"
    }
  }), _c('br'), _c('br'), _vm._v("\n  5.操作后请到以下地址查询是否注册成功（SEP查询注册结果使用方法）"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4), _c('br'), _vm._v("\n  6.使用工具重新注册后请再次查询注册结果，如仍未注册成功的，请将【mis账号+软件安装成功的图标截图】提供给【6000帮助台】"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("六、常见问题FAQ ")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#0099FF"
    }
  }, [_vm._v("Q：我为什么要安装？不安装又会怎么样呢？ ")]), _c('br'), _vm._v("\n  A：近半年来，公司办公网几乎每月都有多起病毒感染事件发生，导致电脑无法正常运行、电脑中的文件被删除、信息被窃取等，不仅影响自身办公，还可能病毒传播影响他人电脑，影响公司安全！"), _c('br'), _vm._v("\n  另外，根据公司制度规定，员工应做好本人使用和管理的计算机的防病毒工作，不得随意卸载防病毒软件或改变安全配置。若重新安装了计算机操作系统，应及时安装防病毒软件。"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#0099FF"
    }
  }, [_vm._v("Q: 怎样区分我的电脑是否需要安装？")]), _c('br'), _vm._v("\n  A：符合以下任意一个条件的电脑都需要安装，无论是自己买的电脑，还是公司配的。若有多台，均需安装。"), _c('br'), _vm._v("\n  1. 用于办公用途的电脑，包括但不限于:"), _c('br'), _vm._v("\n  使用浏览器登录使用任何公司web系统，包括但不限于web邮件、sankuai门户、HR平台等"), _c('br'), _vm._v("\n  使用outlook、apple mail等邮件客户端软件收发邮件"), _c('br'), _vm._v("\n  使用git等软件链接代码仓库进行开发工作"), _c('br'), _vm._v("\n  直接登录或跳板登录公司服务器"), _c('br'), _vm._v("\n  存储公司资料的机器"), _c('br'), _vm._v("\n  其他"), _c('br'), _vm._v("\n  2. 接入公司网络"), _c('br'), _vm._v("\n  通过有线连接公司网络"), _c('br'), _vm._v("\n  通过无线连接公司网络"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#0099FF"
    }
  }, [_vm._v("Q：安装了杀毒软件会对我的电脑造成什么影响？ ")]), _c('br'), _vm._v("\n  A：公司采购的杀毒软件是国际知名安全厂商软件，已在各大公司有非常多年普及的经验。信息安全中心自Q1试点推广以来，低于1‰的员工可能遇到异常，包括电脑性能不足、蓝屏等，可能影响办公。当发生这些情况时，请及时联系6000或当地IT解决，或禁用、卸载。"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#0099FF"
    }
  }, [_vm._v("Q：杀毒软件会做什么事情，会监控我的电脑吗？")]), _c('br'), _vm._v("\n  A：杀毒软件的主要功能为防范电脑病毒、木马或恶意软件，保护终端安全。为了实现其安全功能，杀毒软件会检测系统运行的程序，使用不限于特征匹配等方式检测恶意程序；同时，杀毒软件也会监控网络流量，防止恶意攻击等。请大家放心，"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("杀毒软件不会监控员工操作电脑行为、聊天记录、隐私数据等。")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("如大家还有别的疑问，请及时反馈给我们，我们将及时为您解答。谢谢！")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("访问IT门户："), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "href": "https://itportal.sankuai.com/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("https://itportal.sankuai.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/saimenInstallForWin/saimenInstallForWin_pic17.png"),
      "width": "700px",
      "height": "380px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#F0FFF0"
    }
  }, [_c('span', [_vm._v("杀毒软件安装时，会提示填写mis账号，或通过资产信息识别使用者，可通过以下方式查看是否注册成功。 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#FFF5EE"
    }
  }, [_c('span', [_vm._v("运行信息安全中心提供的注册工具，重新注册一下即可。无须重新安装杀毒软件！"), _c('br'), _vm._v("\n  此工具请在连接MTDP网络状态下使用")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "10",
      "cellspacing": "0",
      "width": "90%"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#F5F5F5"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('th', [_vm._v("代码块")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("https://reg-sec.meituan.com/api/symantec/status?mis=请输入你的mis账号")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62885544!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/saimenInstallForWin.vue
// module id = 648
// module chunks = 1